export default __webpack_public_path__ + "static/media/kikkers.c617d6f1.png";